import { StyleSheet } from '@react-pdf/renderer';

export const globalStyles = StyleSheet.create({
  marginBottom: {
    marginBottom: '30px',
  },
});
